import {RefObject} from "react";
import {css} from "@panda/css";

interface IProps {
    offsetTop: number;
    ref: RefObject<HTMLTableSectionElement | null>;
}

export const ScrollRefOffset = (props: IProps) => {
    const {offsetTop, ref} = props;

    return (
        <div
            className={css({
                position: "relative"
            })}
        >
            <div
                ref={ref}
                className={css({
                    position: "absolute",
                    top: offsetTop + "px"
                })}
            />
        </div>
    );
};
import {RefObject} from "react";
import {css} from "@panda/css";

interface IProps {
    offsetTop: number;
    ref: RefObject<HTMLTableSectionElement | null>;
}

export const ScrollRefOffset = (props: IProps) => {
    const {offsetTop, ref} = props;

    return (
        <div
            className={css({
                position: "relative"
            })}
        >
            <div
                ref={ref}
                className={css({
                    position: "absolute",
                    top: offsetTop + "px"
                })}
            />
        </div>
    );
};
